import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FinancialManagementService} from '../_services/financial-management.service';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {FinancialSetting} from '../_models/financial-management.model';
import {DatePipe} from '@angular/common';
import {FinancialChartAccountOptions} from '../_models/financial-account.model';
import {FinancialChartService} from '../_services/financial-chart.service';

@Component({
    selector: 'acabim-admin-financial-settings',
    templateUrl: './financial-settings.component.html',
    styleUrls: ['./financial-settings.component.scss'],
    providers: [MessageService]
})
export class FinancialSettingsComponent implements OnInit {
    settings: any;
    periods: { name: string }[] = [];
    intervalTypes: { name: string, id: string }[] = [];
    isLoading = false;
    defaultCurrency: { name: string }[] = [];
    taxType: { name: string }[] = [];
    chartOfAccounts: FinancialChartAccountOptions[] = [];
    accounts: FinancialChartAccountOptions[] = [];
    showContingencyAccounts = false;
    showRentPaymentAccounts = false;
    showRentIncomeAccounts = false;

    constructor(
        private readonly financialService: FinancialManagementService,
        private readonly financialChartService: FinancialChartService,
        private messageService: MessageService,
        private primengConfig: PrimeNGConfig,
        private datePipe: DatePipe
    ) {
        this.initForm();
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.isLoading = true;
        this.financialService.getFinancialPeriods().subscribe(periodData => {
            this.periods = [];
            periodData.forEach(str => {
                this.periods.push({name: str});
            });
            this.financialService.getInterval().subscribe(data => {
                this.intervalTypes = [];
                this.intervalTypes.push({name: data.currentMonth, id: 'currentMonth'});
                this.intervalTypes.push({name: data.daysAfter, id: 'daysAfter'});
                this.intervalTypes.push({name: data.daysAfterMonth, id: 'daysAfterMonth'});
                this.intervalTypes.push({name: data.followingMonth, id: 'followingMonth'});
                this.financialService.getTaxType().subscribe(taxData => {
                    this.taxType = [];
                    taxData.forEach(str => {
                        this.taxType.push({name: str});
                    });
                    this.financialService.getDefaultCurrency().subscribe(currrencyData => {

                        this.defaultCurrency = [];
                        currrencyData.forEach(str => {
                            this.defaultCurrency.push({name: str});
                        });
                        this.financialService.getCurrentSettings().subscribe(currentSettingData => {
                            console.dir(currentSettingData);
                            this.financialChartService.getChartOfAccountsAsOptions(false, true).subscribe(accounts => {
                                this.accounts = accounts;
                                console.dir(this.accounts );
                                this.settings.get('enable_financial').patchValue(currentSettingData?.enabled === 1 ? true : false);
                                if (currentSettingData.enabled === 1) {
                                    this.settings.get('maintenanceItems').patchValue(currentSettingData?.maintenance_items === 1 ? true : false);
                                    const startDate: string | null = currentSettingData.reporting_period_start_date ? currentSettingData.reporting_period_start_date.toString() : null;
                                    const period = this.periods.filter(x => x.name === currentSettingData.reporting_period)[0];
                                    this.settings.get('period').patchValue(period);
                                    this.settings.get('startDate').patchValue(startDate ? new Date(startDate) : null);
                                    const interval = this.intervalTypes.filter(x => x.id === currentSettingData.default_payment_period_interval)[0];
                                    this.settings.get('interval').patchValue(interval);
                                    this.settings.get('intervalValue').patchValue(currentSettingData.default_payment_period_value);
                                    const currency = this.defaultCurrency.filter(x => x.name === currentSettingData.default_currency)[0];
                                    this.settings.get('currency').patchValue(currency);
                                    const tax = this.taxType.filter(x => x.name === currentSettingData.default_tax)[0];
                                    this.settings.get('tax').patchValue(tax);
                                    let CFAccount = null;
                                    this.accounts.map((data) => {
                                        const match = data.items.filter(x => x.value === currentSettingData?.contingency_fund).shift();
                                        if(match) {
                                            CFAccount = match.value;
                                        }
                                    });
                                    if (CFAccount) {
                                        this.settings?.get('contingency')?.setValue(true);
                                        this.showContingencyAccounts = true;
                                        this.settings?.get('contingencyFund')?.setValue(CFAccount);
                                    } else {
                                        this.settings?.get('contingency')?.setValue(false);
                                        this.showContingencyAccounts = false;
                                        this.settings?.get('contingencyFund')?.setValue(null);
                                    }
                                    let PLAccount = null;
                                    this.accounts.map((data) => {
                                        const match = data.items.filter(x => x.value === currentSettingData?.property_lease_rent_income_account).shift();
                                        console.dir(currentSettingData?.property_lease_rent_income_account);
                                        console.dir(match);
                                        if(match) {
                                            PLAccount = match.value;
                                            console.dir(PLAccount);
                                        }
                                    });
                                    if (PLAccount) {
                                        this.settings?.get('propLeaseRentIncome')?.setValue(true);
                                        this.showRentIncomeAccounts = true;
                                        this.settings?.get('propLeaseRentIncomeAccount')?.setValue(PLAccount);
                                    } else {
                                        this.settings?.get('propLeaseRentIncome')?.setValue(false);
                                        this.showRentIncomeAccounts = false;
                                        this.settings?.get('propLeaseRentIncomeAccount')?.setValue(null);
                                    }
                                    let PLPayAccount = null;
                                    this.accounts.map((data) => {
                                        const match = data.items.filter(x => x.value === currentSettingData?.property_lease_rent_payment_account).shift();
                                        if(match) {
                                            PLPayAccount = match.value;
                                        }
                                    });
                                    if (PLPayAccount) {
                                        this.settings?.get('propLeaseRentPayment')?.setValue(true);
                                        this.showRentPaymentAccounts = true;
                                        this.settings?.get('propLeaseRentPaymentAccount')?.setValue(PLPayAccount);
                                    } else {
                                        this.settings?.get('propLeaseRentPayment')?.setValue(false);
                                        this.showRentPaymentAccounts = false;
                                        this.settings?.get('propLeaseRentPaymentAccount')?.setValue(null);
                                    }
                                }
                                this.isLoading = false;
                            }, error => {
                                this.isLoading = false;
                            });
                        }, error => {
                            this.isLoading = false;
                        });
                    }, error => {
                        this.isLoading = false;
                    });
                }, error => {
                    this.isLoading = false;
                });
                this.onChange();
            }, error => {
                this.isLoading = false;

            });
        });

    }

    initForm(): void {
        this.settings = new FormGroup({
            enable_financial: new FormControl(false),
            period: new FormControl(null),
            startDate: new FormControl(null),
            interval: new FormControl(null),
            intervalValue: new FormControl(null),
            currency: new FormControl(null),
            tax: new FormControl(null),
            contingency: new FormControl(false),
            contingencyFund: new FormControl(false),
            maintenanceItems: new FormControl(false),
            propLeaseRentPayment: new FormControl(false),
            propLeaseRentPaymentAccount: new FormControl(false),
            propLeaseRentIncome: new FormControl(false),
            propLeaseRentIncomeAccount: new FormControl(false),
            account: new FormControl(null),
        });
    }

    onChange(): void {
        this.settings?.get('propLeaseIncomeRentAccount')?.valueChanges.subscribe((data: any) => {
            console.dir(data);
        });
        this.settings?.get('contingency')?.valueChanges.subscribe((data: any) => {
            console.dir(data);
            this.showContingencyAccounts = data;
        });
        this.settings?.get('contingencyFund')?.valueChanges.subscribe((data: any) => {
            console.dir(data);
        });
        this.settings?.get('propLeaseRentIncome')?.valueChanges.subscribe((data: any) => {
            this.showRentIncomeAccounts = data;
        });
        this.settings?.get('propLeaseRentPayment')?.valueChanges.subscribe((data: any) => {
            this.showRentPaymentAccounts = data;
        });
        this.settings?.get('enable_financial')?.valueChanges.subscribe((data: any) => {
        });
    }

    onSubmit() {
        if (this.settings.valid) {
            this.isLoading = true;
            console.dir(this.settings.get('contingencyFund').value);
            const settingModel: FinancialSetting = {
                default_payment_period_interval: this.settings.get('interval').value?.id,
                default_payment_period_value: this.settings.get('intervalValue').value,
                enable: this.settings.get('enable_financial').value ? 1 : 0,
                reporting_period_start_date: this.settings.get('startDate').value,
                reporting_period: this.settings.get('period').value?.name,
                default_currency: this.settings.get('currency').value?.name,
                default_tax: this.settings.get('tax').value?.name,
                contingency_fund: this.showContingencyAccounts && this.settings.get('contingencyFund').value ? this.settings.get('contingencyFund').value : 0,
                maintenance_items: this.settings.get('maintenanceItems').value ? 1 : 0,
                property_lease_rent_income_account: this.showRentIncomeAccounts && this.settings.get('propLeaseRentIncomeAccount').value ? this.settings.get('propLeaseRentIncomeAccount').value : 0,
                property_lease_rent_payment_account : this.showRentPaymentAccounts && this.settings.get('propLeaseRentPaymentAccount').value ? this.settings.get('propLeaseRentPaymentAccount').value : 0
            };
            console.dir(settingModel);
            this.financialService.setCurrentSettings(settingModel).subscribe(data => {
                this.isLoading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Account settings updated'
                });
            }, error => {
                this.isLoading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.detail
                });
            });

        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please fill all required fields'
            });
        }
    }

    getDate(date: string): string {
        const newDate = new Date(date);
        return (this.datePipe.transform(newDate, 'dd/MMM/yyyy') as string);
    }

}
